import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	TemplateRef,
	ViewChild
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Solution } from 'src/app/shared/models/solution';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { forkJoin } from 'rxjs';

//SLIDER
import { Options } from '@angular-slider/ngx-slider';
import { OptimCriteria } from 'src/app/shared/models/optim-criteria';
import { OptimConstraint } from 'src/app/shared/models/optim-constraint';
import { Employee } from 'src/app/shared/models/employee/employee';

@Component({
	selector: 'app-build-solution',
	templateUrl: './build-solution.component.html',
	styleUrls: ['./build-solution.component.scss']
})
export class BuildSolutionComponent implements OnInit {
	@Input() solution: Solution;
	@Input() employees: Employee[];
	@Output() setIsLoadingSolutionAndTriggerChangeDetection: EventEmitter<any> =
		new EventEmitter();
	@Output() getDataForPlanning: EventEmitter<any> = new EventEmitter();
	@Output() launchEventBusSubscription: EventEmitter<any> = new EventEmitter();

	selectedWeekNumber: number;
	selectedYearNumber: number;

	builderLaunched = false;
	textBuild = 'Démarrer la planification';
	buildInProgress = 'Envoi de la demande de planification ...';
	textToDisplay = this.textBuild;
	selectedCenterId;

	isSSIAD: boolean = this.facade.dataStorageService.isSSIAD();
	isSAAD: boolean = this.facade.dataStorageService.isSAAD();
	isSESSAD: boolean = this.facade.dataStorageService.isSESSAD();
	isSAE: boolean = this.facade.dataStorageService.isSAE();

	displayEmployeeSelection = false;
	@Input() constraint: string = '';

	replanifDaysDefaultValues = [false, false, false, false, false, false, false];

	isOptimParamsEditable: boolean = false;

	isVehicleActive: boolean = this.facade.dataStorageService.isVehiculeActive();
	isOptimVehicleActive: boolean =
		this.facade.dataStorageService.isOptimVehicleActive();

	optimParams: {
		replanifDays: boolean[];
		employees: number[]; // uniquement les ids des employés !
		optimCriteria: OptimCriteria;
		optimConstraint: OptimConstraint;
		assignEmployees: boolean;
		assignVehicles: boolean;
		resetEmployees: boolean;
		resetVehicles: boolean;
	} = {
		replanifDays: this.replanifDaysDefaultValues,
		employees: [],
		optimCriteria: null,
		optimConstraint: null,
		assignEmployees: true,
		assignVehicles: this.isOptimVehicleActive,
		resetEmployees: true,
		resetVehicles: this.isOptimVehicleActive
	};

	//Mapping pour traduire labels des contraintes
	mapConstraint = {
		intervenantAbsent: { name: "Abscence de l'intervenant", display: false },
		intervenantIncompatible: {
			name: 'Respecter les incompatibilités Bénéficiaire / Intervenant',
			display: true
		},
		matchingCompetence: { name: 'Respect de la compétence', display: false },
		outOfDayTimeRange: { name: '', display: false },
		outOfDayWorkingTime: {
			name: "Interdire l'excès de quota de travail quotidien",
			display: true
		},
		outOfWeekWorkingTime: {
			name: "Interdire l'excès de quota de travail hebdomadaire",
			display: true
		},
		overlapping: { name: 'Chevauchement entre les missions', display: false },
		overlappingComeBackAbsence: { name: '', display: false },
		overlappingLunchBreak: {
			name: 'Chevauchement pause-déjeuner',
			display: false
		},
		overlappingTravelTime: { namme: '', display: false },
		sectorMatch: { name: 'Appliquer la sectorisation', display: true }
	};

	//Mapping pour traduire labels des contraintes
	mapCriteria = {
		extraWorkingTimeWeight: {
			name: 'Heures supplémentaires',
			display: true,
			order: 4
		},
		id: { name: '', display: false },
		label: { name: '', display: false },
		travelDistanceWeight: {
			name: 'Distance parcourue',
			display: true,
			order: 1
		},
		twLateArrivalTimeWeight: {
			name: 'Minimisation des retards',
			display: !this.isSESSAD,
			order: 2
		},
		stdDevTravelDistanceWeight: {
			name: 'Equilibrage les distances parcourues',
			display: true,
			order: 3
		},
		maxTravelDistanceWeight: { name: '', display: false },
		maxWaitingTimeWeight: { name: '', display: false },
		payableWaitingTimeWeight: { name: '', display: false },
		notUsedWorkingTimeWeight: {
			name: 'Heures non travaillées',
			display: true,
			order: 5
		},
		stdDevExtraWorkingTimeWeight: { name: '', display: false },
		stdDevNotUsedWorkingTimeWeight: { name: '', display: false },
		stdDevTravelTimeWeight: { name: '', display: false },
		specialtiesUnsatisfiedWeight: {
			name: 'Correspondance des spécialités',
			display: !this.isSSIAD,
			order: 6
		},
		unassignedMissionsWeight: { name: '', display: false },
		preferredIntervenantWeight: {
			name: 'Préférences bénéficiaire / intervenant',
			display: true,
			order: 3
		},
		stdDevWorkingTimeWeight: { name: '', display: false },
		waitingTimeWeight: { name: '', display: false },
		travelTimeWeight: { name: '', display: false },
		serviceTimeWeight: { name: '', display: false },
		workingTimeWeight: { name: 'Temps de travail', display: false }
	};

	isAllWeekSelected = false;
	replanifDaysString = [
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi',
		'Dimanche'
	];

	@ViewChild('modalLaunchBuild', { static: true })
	modalLaunchBuild: TemplateRef<any>;
	@ViewChild('buildPerformancesModal', { static: true })
	buildPerformancesModal: TemplateRef<any>;
	@ViewChild('confirmRescheduleModal', { static: true })
	confirmRescheduleModal: TemplateRef<any>;
	solutionPerformances: string[];

	bsModalLaunchBuild: BsModalRef;
	bsModalBuildPerformances: BsModalRef;
	bsModalConfirmReschedule: BsModalRef;

	labelIntervention: string;

	options: Options = {
		floor: 0,
		ceil: 10
	};

	constructor(
		public dateUtils: DateUtils,
		private logger: LogService,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
		this.selectedCenterId =
			this.facade.dataStorageService.getUser()?.employee.serviceCenter.id;
		this.isOptimParamsEditable =
			this.facade.dataStorageService.isOptimParamsEditable();

		this.isVehicleActive = this.facade.dataStorageService.isVehiculeActive();
	}

	selectAllWeek() {
		this.isAllWeekSelected = !this.isAllWeekSelected;
		this.isAllWeekSelected
			? this.optimParams.replanifDays.fill(true)
			: this.optimParams.replanifDays.fill(false);
	}

	selectEmp(emp?: Employee) {
		if (!emp) {
			if (this.optimParams.employees.length !== this.employees.length) {
				this.optimParams.employees = [...this.employees.map((emp) => emp.id)];
			} else {
				this.optimParams.employees = [];
			}
		} else if (this.optimParams.employees.includes(emp.id)) {
			const index = this.optimParams.employees.indexOf(emp.id);
			if (index > -1) {
				this.optimParams.employees.splice(index, 1);
			}
		} else {
			this.optimParams.employees.push(emp.id);
		}
	}

	getEmployeeSkillsAsString(employee: any): string {
		if (!employee || !employee.careSkills) {
			return 'Sans';
		}

		const skills = employee.careSkills;
		if (skills.length > 0) {
			return skills.map((skill) => skill.name || 'Sans').join(' | ');
		}

		return 'Sans';
	}

	getEmployeeDisplayName(employee: any): string {
		if (!employee) {
			return 'Aucun';
		}
		return `${employee.firstName} ${
			employee.lastName
		} (${this.getEmployeeSkillsAsString(employee)})`;
	}

	onResetEmployeesClick() {
		// si on reset les employés, les véhicules sont reset également
		if (this.optimParams.resetEmployees) {
			this.optimParams.resetVehicles = true;
		}
	}

	buildSolution() {
		this.builderLaunched = true;
		this.textToDisplay = this.buildInProgress;
		this.facade.solutionService
			.postBuildSolutionByYearAndWeekNumber(
				this.selectedYearNumber,
				this.selectedWeekNumber,
				this.optimParams
			)
			.subscribe({
				complete: () => {
					this.logger.log(
						'Build solution : ' +
							this.selectedYearNumber +
							' - ' +
							this.selectedWeekNumber
					);
					this.builderLaunched = false;
					this.textToDisplay = this.textBuild;

					this.getDataForPlanning.emit({
						reloadEmployeesAndVacation: false,
						reloadSolution: true,
						reloadOptimInProgress: true
					});
					this.bsModalLaunchBuild.hide();
					this.facade.toastService.createInfoToast(
						'Demande de planification transmise avec succès.'
					);

					this.builderLaunched = false;
					this.optimParams.replanifDays.fill(false); // reset des replanifDays
					this.isAllWeekSelected = false;

					// this.textToDisplay = this.textBuild;
					// this.solutionPerformances = solution?.message?.split('\n');
					// this.bsModalBuildPerformances = this.modalService.show(
					// 	this.buildPerformancesModal
					// );

					this.launchEventBusSubscription.emit();

					this.setIsLoadingSolutionAndTriggerChangeDetection.emit(true);
					this.bsModalLaunchBuild.hide();
				},
				error: (err) => {
					if (err?.error?.response) {
						this.facade.toastService.createHttpErrorToast(
							err?.error?.response ? err?.error?.response : '',
							err?.status
						);
					} else {
						this.facade.toastService.createErrorToast(
							"L'opération demandée n'a pas pu aboutir, vérifier la période sélectionnée"
						);
					}
					this.logger.log('error : ', err?.error?.response);
					this.builderLaunched = false;
					this.optimParams.replanifDays.fill(false);
					this.isAllWeekSelected = false;
					// this.textToDisplay = this.textBuild;
					// this.modal.dismissAll();
				}
			});
	}

	openConfirmRescheduleModal() {
		this.bsModalConfirmReschedule = this.modalService.show(
			this.confirmRescheduleModal,
			{ class: 'modal-lg' }
		);
	}

	isReplanifDaysEmpty() {
		return !this.optimParams.replanifDays.includes(true);
	}

	isLaunchButtonDisabled() {
		const isResetButtonActive =
			(this.optimParams.resetEmployees || this.optimParams.resetVehicles) &&
			this.optimParams.replanifDays.includes(true);
		const isAssignButtonActive =
			this.optimParams.assignEmployees || this.optimParams.assignVehicles;
		return (
			this.builderLaunched ||
			this.selectedWeekNumber < 1 ||
			this.selectedWeekNumber > 54 ||
			(!isResetButtonActive && !isAssignButtonActive)
		);
	}

	/* ouverture modal */
	launchBuild(close?: boolean) {
		if (close) {
			this.bsModalLaunchBuild?.hide();
		} else {
			this.selectedWeekNumber = this.solution.weekNumber;
			this.selectedYearNumber = this.solution.year;

			// on réinitialise à la réouverture :
			this.optimParams.replanifDays.fill(false);
			this.isAllWeekSelected = false;
			this.optimParams.employees = [];

			if (this.isOptimParamsEditable) {
				let params = forkJoin({
					constr: this.getOptimConstraint(),
					crit: this.getOptimCriteria()
				});

				params.subscribe(({ crit, constr }) => {
					this.optimParams.optimCriteria = crit;
					this.optimParams.optimConstraint = constr;
				});
			}

			this.bsModalLaunchBuild = this.modalService.show(this.modalLaunchBuild, {
				class: 'modal-lg',
				backdrop: 'static'
			});
		}
	}

	// CRITERIA
	getOptimCriteria() {
		return this.facade.solutionService.getSolutionWithCriteria(
			this.selectedCenterId
		);
	}
	updateCriteria(value?: number, criteria?: string) {
		this.optimParams.optimCriteria[criteria] = value;
	}
	getCriteriaDisplay(criteria: string) {
		return this.mapCriteria[criteria]?.display;
	}

	getCriteriaLabel(criteria: string) {
		return this.mapCriteria[criteria]?.name;
	}

	getCriteriaOrder(criteria) {
		return this.mapCriteria[criteria?.order];
	}

	// CONSTRAINTS
	getOptimConstraint() {
		return this.facade.solutionService.getSolutionWithConstraint(
			this.selectedCenterId
		);
	}
	updateConstraintValue(value, constraint) {
		this.optimParams.optimConstraint[constraint] = value;
	}
	getConstraintLabel(label): string {
		return this.mapConstraint[label]?.name;
	}
	getConstraintDisplay(label): boolean {
		return this.mapConstraint[label]?.display;
	}

	increaseOrDecreaseWeekNumber(operation?: string) {
		if (operation === '-') {
			this.selectedWeekNumber--;
		} else if (operation === '+') {
			this.selectedWeekNumber++;
		}

		if (this.selectedWeekNumber < 1 || this.selectedWeekNumber > 54) {
			this.selectedWeekNumber = this.solution.weekNumber;
		}
	}

	increaseOrDecreaseYear(operation?: string) {
		if (operation === '-') {
			this.selectedYearNumber--;
		} else if (operation === '+') {
			this.selectedYearNumber++;
		}
	}

	changeReplanifDays(indexDayToChange: number) {
		this.optimParams.replanifDays[indexDayToChange] =
			!this.optimParams.replanifDays[indexDayToChange];
		this.isAllWeekSelected = false;
	}
}
